import { Component, EventEmitter, Input, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DialogResult } from '@progress/kendo-angular-dialog';
import { CustomDialogSettings } from 'src/app/shared/model/CustomDialogSettings';
import { ReferenceType } from 'src/app/shared/model/ReferenceType';
import { CustomDialogService } from 'src/app/shared/services/custom-dialog.service';
import { LinkedPortalUsersComponent } from '../linked-portal-users/linked-portal-users.component';

@Component({
  selector: 'linked-portal-users-icon',
  templateUrl: './linked-portal-users-icon.component.html',
  styleUrls: ['./linked-portal-users-icon.component.scss']
})
export class LinkedPortalUsersIconComponent {

  constructor(
    private customDialogService: CustomDialogService,
    private translateService: TranslateService) { }

  @Input() counter = 0;
  @Input() referenceType: ReferenceType;
  @Input() referenceId: number;
  @Output() linkedUserChangeEvent = new EventEmitter<string>();

  @ViewChild("linkedUsersDialog", { read: ViewContainerRef })
  public containerRef: ViewContainerRef;



  showLinkedUsers(){

    const dialogSettings: CustomDialogSettings = {
      content: LinkedPortalUsersComponent,
      title: `${this.translateService.instant('admin-center.user.linkedUsers')}`,
      maxWidth: '60vw',
      maxHeight: '60vh',
      appendTo:this.containerRef,
      dialogInputs: {
        referenceType : this.referenceType,
        referenceId : this.referenceId
      },
      resultCallback: (r: DialogResult) => {
            this.linkedUserChangeEvent.emit("changed");
      }          
    };

    this.customDialogService.showDialog(dialogSettings);
   
  }
}
